import { errorFragment as GQLErrorFragment } from 'queries/__generated__/errorFragment';
import { datadogLogs } from '@datadog/browser-logs';

export default function errorLogger(message: string) {
  return (error?: Error | GQLErrorFragment | string | object | undefined) => {
    const Rollbar = (window as any).Rollbar || {};
    console.warn(error);

    if (Rollbar && typeof Rollbar.error === 'function') {
      const rollbarUuid = Rollbar.error(message, error);
      if (!rollbarUuid) {
        datadogLogs.logger.warn(error as any);
        datadogLogs.logger.error(message);
        // we should only console.error if we did not successfully log the error to Rollbar
        // otherwise, we'll log twice to Rollbar because we send ALL console.errors to Rollbar
        console.error(message);
      } else {
        // console.log if we did successfully log the error to Rollbar
        console.log(message);
      }
    }
  };
}
